import NewsComp from "../../components/news/NewsComp"
import { useTranslation } from "react-i18next"

export default function News005() {

    const { t } = useTranslation()

    const newsText = [
        t('news:news.5.p1'),
        t('news:news.5.p2'),
        t('news:news.5.p3'),
        t('news:news.5.p4'),
        t('news:news.5.p5'),
        t('news:news.5.p6')
    ]

    const newsImage = [
        "news005-img1.jpg",
        "news005-img2.jpg",
        "news005-img3.jpg",
        "news005-img4.jpg",
        "news005-img5.jpg",
        "news005-img6.jpg",
        "news005-img7.jpg"
    ]
    return (
        <div>
            <NewsComp
                newsImage={newsImage}
                newsText={newsText}
                date="2021-04-01"
                headline={t('news:headline.5')}
            />
        </div>
    )
}
